import {
  initialState,
  ISendToState,
  SendToDispatchTypes,
  SEND_TO,
  SEND_TO_FAIL,
  SEND_TO_LOGIN_FALLBACK,
  SEND_TO_SUCCESS,
} from '.'

export const sendToReducer = (state = initialState, action: SendToDispatchTypes): ISendToState => {
  switch (action.type) {
    case SEND_TO:
      return {
        data: null,
        error: null,
        isLoading: true,
      }
    case SEND_TO_LOGIN_FALLBACK:
      return {
        data: null,
        error: null,
        isLoading: true,
      }
    case SEND_TO_SUCCESS:
      return {
        data: action.payload,
        error: null,
        isLoading: false,
      }
    case SEND_TO_FAIL:
      return {
        data: null,
        isLoading: false,
        error: action.payload,
      }

    default:
      return state
  }
}
